module.exports = __webpack_public_path__ + "static/media/jupiter.5bfedde9.png";